import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import { isWebNotCapacitor } from "src/utils/platformUtils";
import styles from "../../content/pages/homepage.module.css";

interface HelpStandaloneShellProps {
  title: string;
  onBack: () => void;
  children: React.ReactNode;
}

/** Public /faq and /glossary page chrome — mirrors HelpMenu drawer layout without close button. */
function HelpStandaloneShell({ title, onBack, children }: HelpStandaloneShellProps) {
  return (
    <Box
      sx={{
        height: "100vh",
        overflow: "hidden",
        // Black outer frame so the 720px column reads like the in-app drawer (same as ArticlesPage).
        bgcolor: "#000000",
        "&::-webkit-scrollbar": { display: "none" },
        scrollbarWidth: "none",
      }}
    >
      <Box
        className={styles.noScrollbar}
        sx={{
          width: { xs: "100%", sm: "720px", md: "720px", lg: "720px" },
          margin: { xs: "0", sm: "0 auto", md: "0 auto", lg: "0 auto" },
          height: isWebNotCapacitor() ? "100%" : "100vh",
          display: "flex",
          flexDirection: "column",
          border: `1px solid ${PureLightThemeCaaS.colors.alpha.white[30]}`,
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          overflow: "hidden",
          bgcolor: "#EDEDED",
        }}
      >
        <Box
          sx={{
            flexShrink: 0,
            borderBottom: `1px solid ${PureLightThemeCaaS.colors.alpha.black[100]}`,
            bgcolor: "#EDEDED",
          }}
        >
          <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" p={1}>
            <IconButton aria-label="back" onClick={onBack} size="small">
              <ArrowBackIcon sx={{ color: PureLightThemeCaaS.colors.alpha.black[100] }} />
            </IconButton>
            <Typography variant="h4" fontSize="16px" color={PureLightThemeCaaS.colors.alpha.black[100]}>
              {title}
            </Typography>
            <Box sx={{ width: 40 }} />
          </Box>
        </Box>
        <Box sx={{ flex: 1, minHeight: 0, position: "relative", overflow: "hidden", display: "flex", flexDirection: "column" }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}

export default HelpStandaloneShell;
